import React from "react";
import "./styles.scss";

const Index = (props) => (
  <>
    <div
      className={`selection-card-wrapper text-center ${props.size} ${props.isSelected ? "active-this" : ""}`}
      onClick={props.onClick}
    >
      <div className={"d-flex flex-column justify-content-center align-items-center "}>
        <div className={"sc-icon"}>{props.cardIcon}</div>
        <div className={"sc-text"}>{props.text}</div>
      </div>
    </div>
  </>
);
export default Index;
